import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur rättas kunskapsprovet?";
const SHORT_ANSWER = "Provet rättas automatiskt i Folkhälsomyndighetens digitala system direkt efter att du lämnat in.";

export const Route = createFileRoute("/fraga/hur-rattas-provet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur rättas kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Du får besked om godkänt/underkänt omedelbart eller inom någon dag, och kommunen får detaljresultat per kunskapsområde. Det går att se vilket område som fällde dig."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – så går rättningen till" }}
      related={[{"to": "/fraga/vilken-paragraf-styr-kunskapsprovet", "label": "Vilken paragraf styr kunskapsprovet?"}, {"to": "/fraga/far-funktionshindrade-extra-tid", "label": "Får funktionshindrade extra tid på kunskapsprovet?"}, {"to": "/fraga/far-jag-rast-under-provet", "label": "Får jag ta rast under kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur rättas kunskapsprovet?" },
      { name: "description", content: "Provet rättas automatiskt i Folkhälsomyndighetens digitala system direkt efter att du lämnat in." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-rattas-provet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-rattas-provet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-rattas-provet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur rättas kunskapsprovet", url: "https://alkoholprovet.se/fraga/hur-rattas-provet" },
      ]),
    ],
  }),
});
